import { Reveal } from "../components/Reveal";
import { API } from "../lib/api";

const IMG_A =
  "https://images.unsplash.com/photo-1611255550543-b5ecb01dfddc?crop=entropy&cs=srgb&fm=jpg&q=85&w=900";
const IMG_B = `${API}/images/model:acuarela`;

export default function Historia() {
  return (
    <section id="historia" data-testid="historia-section" className="py-24 md:py-36 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-16 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1 relative">
          <Reveal className="relative rounded-[2rem] overflow-hidden aspect-[4/5] max-w-md">
            <img src={IMG_A} alt="Calma y bienestar" className="w-full h-full object-cover" />
          </Reveal>
          <Reveal
            delay={0.2}
            className="absolute -bottom-10 right-0 lg:right-6 w-40 md:w-52 rounded-2xl overflow-hidden border-4 border-white shadow-lg aspect-square"
          >
            <img src={IMG_B} alt="Documentación organizada" className="w-full h-full object-cover" />
          </Reveal>
        </div>

        <div className="lg:col-span-6 order-1 lg:order-2">
          <Reveal>
            <p className="overline mb-6">
              <span className="text-[#D7C6A3]">01</span> &nbsp;/&nbsp; Nuestra historia
            </p>
            <h2 className="font-display text-4xl md:text-5xl text-[#2D3732] leading-[1.05] max-w-xl">
              Una solución creada por una paciente para pacientes.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-8 space-y-5 text-[#4A554E] leading-relaxed max-w-xl font-light">
              <p>
                Enfermé siendo apenas una niña de 23 años. Desde entonces mi vida se llenó
                de informes, analíticas, pruebas y citas con especialistas que no cabían en
                ninguna parte.
              </p>
              <p>
                A día de hoy conservo <strong className="font-normal text-[#2D3732]">más
                de 10 carpetas</strong> con todo mi historial médico de los últimos años,
                organizadas con este mismo sistema y ordenadas cronológicamente. Encontrar
                un informe se convirtió en algo tan sencillo como abrir la carpeta y pasar
                el dedo por el índice.
              </p>
              <p className="font-display text-2xl text-[#2D3732] leading-snug">
                Así nació VITAE by Ana.
              </p>
              <p>
                No es solo una carpeta. Es la herramienta que a mí me funciona cada día y
                que ahora comparto con quien también carga con una enfermedad —visible o
                invisible— para que la vida médica pese un poquito menos.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
